import Validate from './validate';

export default class StringValidation extends Validate {
  private reg: RegExp;

  private errorMessage: string;

  constructor() {
    super();
    this.targets = document.getElementsByClassName('js-string-validation') as HTMLCollectionOf<HTMLInputElement>;
    this.errorPositions = document.getElementsByClassName('js-string-error') as HTMLCollectionOf<HTMLInputElement>;
    this.errorMessage = '数字は利用できません';
    this.reg = new RegExp(/^[^0-9０-９]+$/);
  }

  check(index: number): void {
    const target = this.targets[index];
    const { value } = target;
    if (!this.reg.test(value) && value) {
      Validate.failed(target, this.errorPositions[index], this.errorMessage);
    } else if (value) {
      Validate.resolved(target, this.errorPositions[index]);
    }
  }
}
